var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layoutB"},[_c('div',{staticClass:"layoutBContent"},[_vm._t("layoutBContent")],2),(_vm.$slots.pageBlock && _vm.$slots.pageBlock.length)?_c('div',{staticClass:"pageBlock"},[_vm._t("pageBlock")],2):_vm._e(),_c('updatePassword',{ref:"updatePassword"}),_c('detailed',{ref:"detailed"}),_c('QHdev',{ref:"QHdev"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }